module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7f9zi"))).then(() => parcelRequire('dJXJK'));